import { Feature, useFeatureFlag } from '@src/components'
import { BillingProduct, Product } from '@src/types'

export const useShouldShowTwoSteloUnits = (product?: Product) => {
  const shouldShowTwoSteloUnits = useFeatureFlag(Feature.ShowTwoSteloUnits)
  if (!product) {
    return false
  }

  return shouldShowTwoSteloUnits && product.key === BillingProduct.SteloCgm_2
}
